import React from "react";
import useSlider from "@hooks/useSlider";
import topimg from "public/designtop.png";
import Image from "next/image";

interface TestimonialSectionPropsArray {
    headerTitle: string;
    avatarImg?: string;
    companyImg?: string;
    nameText: string;
    professionText: string;
}

interface TestimonialSectionProps {
    TestimonialSectionPropsData: TestimonialSectionPropsArray[];
}

const TestimonialSection: React.FC<TestimonialSectionProps> = (props) => {
    const { TestimonialSectionPropsData = [] } = props;
    const { loaded, refCallback, currentSlide, slider } = useSlider();

    return (
        <div className="px-4 py-10">
            <section className="section-testimonial bg-white mx-auto shadow-2xl rounded-3xl mt-10">
                <div ref={refCallback} className="keen-slider" style={{ height: "90%" }}>
                    {TestimonialSectionPropsData.map((data, index) => (
                        <div className="keen-slider__slide slider-card relative" key={index}>
                            <img className="absolute top-0 left w-16 h-12 hidden lg:block" src={topimg} alt="small-image" style={{ left: "5%" }} />

                            <div className="flex flex-col lg:px-20 px-2 space-y-4 w-full h-full lg:space-y-10 lg:py-8">
                                <div className="w-full flex justify-center items-center">
                                    {data.companyImg && <Image width={144} height={40} src={data.companyImg} alt="companyLogo" />}
                                </div>
                                <p className="text-xl lg:text-3xl lg:leading-tight font-medium text-center">{data.headerTitle}</p>
                                <div className="flex flex-col justify-center space-y-2 items-center">
                                    <Image width={64} height={64} className="h-16 w-16 rounded-full " src={data.avatarImg as string} alt="owner-image" />
                                    <p className="text-lg font-medium text-gray-900">{data.nameText}</p>
                                    <p className="text-base font-normal text-gray-500">{data.professionText}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {loaded && slider.current && (
                    <div className="carousal-dots">
                        {[...Array(slider.current.track.details.slides.length).keys()].map((idx) => (
                            <button
                                key={idx}
                                onClick={() => {
                                    slider.current?.moveToIdx(idx);
                                }}
                                className={"carousal-dot" + (currentSlide === idx ? " active" : "")}
                            ></button>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default TestimonialSection;
